"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientSchemaProperties = exports.ZapierClientSchema = exports.ClientSchema = exports.ClientTypeEnum = void 0;
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
const ClientStatusEnum = zod_1.z.enum(["archived", "active", "merged", "deleted"]);
const intuit_realm_1 = require("./intuit-realm");
exports.ClientTypeEnum = zod_1.z.enum(["individual", "company", "family"]);
const CustomFieldSchema = zod_1.z.object({
    value: zod_1.z.any(),
    field: zod_1.z.string(),
    formId: zod_1.z.string().optional(),
});
const FeedItemSchema = zod_1.z.object({
    id: zod_1.z.string().optional(),
    actionId: zod_1.z.string(),
    clientId: zod_1.z.string(),
    createdAt: zod_1.z.date(),
    modifierId: zod_1.z.string(),
    name: zod_1.z.string().optional(),
    resourceId: zod_1.z.string(),
    type: zod_1.z.enum([
        "task",
        "appointment",
        "form",
        "invoice",
        "file",
        "link",
        "thread",
        "note",
        "folder",
    ]),
});
const ClientAddressSchema = zod_1.z.object({
    // @TODO: we should rename it to `billTo`
    name: zod_1.z.string().optional(),
    // @TODO: we should rename it to `billingEmail`
    // @TODO: some documents returns an empty string, and it makes the
    //        `.email()` to worh properly. That is the reason we added `.or()`.
    //        Maybe we should just let it as string until we fix the database?
    email: zod_1.z.string().email().or(zod_1.z.string()).optional(),
    city: zod_1.z.string().optional(),
    country: zod_1.z.string().optional(),
    // @TODO: we should rename this field to `street`.
    line1: zod_1.z.string().optional(),
    postalCode: zod_1.z.string().optional(),
    state: zod_1.z.string().optional(),
});
exports.ClientSchema = base_schema_1.BaseSchema.extend({
    firstName: zod_1.z.string().optional(),
    address: ClientAddressSchema.optional(),
    coachUserId: zod_1.z.string(),
    color: zod_1.z
        .object({
        foreground: zod_1.z.string(),
        background: zod_1.z.string(),
    })
        .optional(),
    company: zod_1.z.string().optional(),
    archivedAt: zod_1.z.date().nullable().optional(),
    email: zod_1.z.string(),
    emails: zod_1.z.array(zod_1.z.string()).optional(),
    lastName: zod_1.z.string().optional(),
    latestActivity: FeedItemSchema.optional(),
    lastMergedActivity: zod_1.z.any().optional(),
    phoneNumber: zod_1.z.string().optional(),
    status: ClientStatusEnum.optional(),
    statusId: zod_1.z.string().optional().nullable(),
    stream: zod_1.z.any().optional(),
    customFields: zod_1.z.array(CustomFieldSchema).optional(),
    timeZone: zod_1.z.string().optional(),
    clientType: exports.ClientTypeEnum,
    members: zod_1.z.array(zod_1.z.object({ id: zod_1.z.string(), joined: zod_1.z.date() })).optional(),
    memberIds: zod_1.z.array(zod_1.z.string()).optional(),
    nameInsensitive: zod_1.z.string().optional(),
    labels: zod_1.z.array(zod_1.z.string()).optional(),
    stripe: zod_1.z.any().optional(),
    quickBooks: intuit_realm_1.IntuitQuickBooksCustomerInfoSchema.optional(),
    tasks: zod_1.z
        .object({
        taskIds: zod_1.z.string().array().optional(),
        title: zod_1.z.string().optional(),
    })
        .optional(),
    avatarURL: zod_1.z.string().nullable().optional(),
    portalJoinedAt: zod_1.z.date().optional(),
    // @TODO: check if we really need this prop. It is currently used in the chat pages
    userId: zod_1.z.string().optional(),
    accountId: zod_1.z.string().optional().nullable(),
    assigneeId: zod_1.z.string().optional(),
    assigneeIds: zod_1.z.string().array().optional(),
    assignedBy: zod_1.z.string().optional(),
    billingContactId: zod_1.z.string().optional(),
    primaryContactId: zod_1.z.string().optional(),
});
/**
 * Schema for a client as it is sent across the wire.
 */
exports.ZapierClientSchema = zod_1.z.object({
    id: zod_1.z.string(),
    firstName: zod_1.z.string().optional(),
    lastName: zod_1.z.string().optional(),
    email: zod_1.z.string().email().optional(),
    timeZone: zod_1.z.string().optional(),
    company: zod_1.z.string().optional(),
    phoneNumber: zod_1.z.string().optional(),
});
exports.ClientSchemaProperties = {
    collectionName: "clients",
    deleteMode: schema_properties_interface_1.DeleteMode.None,
};
//# sourceMappingURL=client-schema.js.map